import gql from 'graphql-tag';
import { scheduledSessionParticipantEntryFieldsFragment } from '../fragments';

export const markEvaluationAsReviewedMutation = gql`
  mutation MarkEvaluationAsReviewed(
    $scheduledSessionId: ID!
    $participantId: ID!
    $evaluationId: ID!
  ) {
    markEvaluationAsReviewed(
      scheduledSessionId: $scheduledSessionId
      participantId: $participantId
      evaluationId: $evaluationId
    ) {
      ...AdminScheduledSessionParticipantEntryFields
    }
  }

  ${scheduledSessionParticipantEntryFieldsFragment}
`;
